import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Client errors will not resolve on their own.
        if (error instanceof ApiError && error.status < 500) return false
        return failureCount < 2
      },
    },
  },
})

export const qk = {
  me: ['me'] as const,
  authConfig: ['auth-config'] as const,
  users: (params?: unknown) => ['users', params ?? null] as const,
  clients: (params?: unknown) => ['clients', params ?? null] as const,
  client: (id: string) => ['client', id] as const,
  contacts: (params?: unknown) => ['contacts', params ?? null] as const,
  projects: (params?: unknown) => ['projects', params ?? null] as const,
  project: (id: string) => ['project', id] as const,
  cases: (params?: unknown) => ['cases', params ?? null] as const,
  case: (id: string) => ['case', id] as const,
  caseDocuments: (id: string) => ['case-documents', id] as const,
  casePayments: (id: string) => ['case-payments', id] as const,
  tasks: (params?: unknown) => ['tasks', params ?? null] as const,
  task: (id: string) => ['task', id] as const,
  templates: ['task-templates'] as const,
  template: (id: string) => ['task-template', id] as const,
  documents: (params?: unknown) => ['documents', params ?? null] as const,
  documentTypes: ['document-types'] as const,
  notifications: ['notifications'] as const,
  myDay: ['my-day'] as const,
  apiTokens: ['api-tokens'] as const,
}
